<div class="row">
  <div class="col-md-12 action-btns-right " style="margin-top:5px;">
    <button *ngIf="!isWatchConsensus && !isSubmitted" mat-raised-button id="submitBtn" class="btn btn-success btn-extra-space-left" (click)="submitCoding()" [disabled]="isSubmitted || !codingSubmittable">Submit</button>
    <button *ngIf="evaluation.watchConsensusVisible" mat-raised-button [ngClass]="(watchConsensusEnabled) ? 'btn btn-success btn-extra-space-left' : 'btn btn-warning btn-extra-space-left'" (click)="watchConsensus()">Watch {{evaluation.startConsensusMergeVisible? "Comparison" :"Consensus"}}</button>
    <button *ngIf="evaluation.startConsensusMergeVisible" mat-raised-button class="btn btn-success btn-extra-space-left" (click)="startConsensus(evaluation.abstractId, evaluation.protocolId)">Start Comparison</button>
    <button *ngIf="evaluation.startConsensusVisible" mat-raised-button class="btn btn-success btn-extra-space-left" (click)="startConsensus(evaluation.abstractId, evaluation.protocolId)">Start Consensus</button>
    <button *ngIf="evaluation.abstract" mat-raised-button class="btn btn-primary" (click)="openAbstractInformationWindow(evaluation.abstractId)">View Abstract</button>
    <button *ngIf="evaluation && (canAddNotes() || canReadNotes())" mat-raised-button class="btn btn-primary" (click)="openDialog()">QC Notes {{evaluation.notes && evaluation.notes.length ? ' (' + evaluation.notes.length + ')' : ''}}</button>
    <button *ngIf="!isSubmitted && !isWatchConsensus" mat-raised-button class="btn btn-danger btn-extra-space-right" (click)="reset()">Reset</button>
    <div class="flagsBox" *ngIf="canRecommendForAdjudication() || canRecommendForReview()">
      <mat-checkbox *ngIf="canRecommendForReview()" class="checkbox-margin" [(ngModel)]="recommendedForODPReview" (click)="recommendForReview(evaluation.evaluationId)" [disabled]="disableODPReview()">QC Coder Question</mat-checkbox>
      <mat-checkbox *ngIf="canRecommendForAdjudication()" class="checkbox-margin" [(ngModel)]="recommendedForODPAdjudication" (click)="recommendForAdjudication(evaluation.evaluationId)" [disabled]="disableAdjudication()">Request ODP Adjudication</mat-checkbox>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-10 offset-md-2 text-left  col-12">
    <h1 class="title">{{evaluation.formTitle}}</h1>
    <div *ngIf="!isSubmitted && !isEvaluationCompleted">
      <div class="odp-sub-header-dark-blue">Check all that apply in each column (topics are not mutually exclusive)</div>
      <div class="odp-sub-header-dark-blue ">See accompanying protocol for definitions and examples</div>
    </div>

    <div *ngIf="isSubmitted && !isSubmissionView" class="alert alert-success">
      Coding form submitted successfully.
    </div>
    <div *ngIf="submittedMessage != ''" class="alert alert-success">
      {{submittedMessage}}
    </div>    

    <div *ngIf="evaluation.abstract" class="abstractBox">
      <p class="eval-detail">Application ID: </p> <p class="bolder-text">{{evaluation.abstract.application}}</p>
      <br />
      <p class="eval-detail">Project Title: </p>  <p class="bolder-title">{{evaluation.abstract.projectTitle | titlecase}}</p>
      <br />
      <p class="eval-detail">PI Project Leader: </p>  <p class="bolder-text">{{evaluation.abstract.piprojectLeader | titlecase}}</p>
      <br />
      <p class="eval-detail">Coded by: </p> <p class="bolder-text">{{this.teamMembers}}</p>
    </div>
  </div>
</div>

<div class="row coding-wrapper" *ngIf="evaluation.codingUISections">
  <div class="col-md-10  offset-md-2 col-12  odp-xs-card-margin-top col-print-12">
    <br />
    <div *ngFor="let section of evaluation.codingUISections; let si = index">
      <mat-card>
        <mat-card-header (click)="toggleCollapseSection(section.id)" style="cursor:pointer">
          <mat-card-title style="cursor:pointer">
            <div class="odp-mat-card-header-text">
              <b>{{section.title}}</b> <span class="fa-stack toolTipCursor"
                                             *ngIf="section.descriptionHtml !=''"
                                             (click)="openProtocolInformationWindow(evaluation.protocol, 'section' + section.sectionItemColumnDescription[0].sectionColumnItemType.sectionAlpha);$event.stopPropagation()">
                <i class="fa fa-square-o fa-stack-2x"></i>
                <i class="fa fa-question fa-stack-1x"></i>
              </span>
            </div>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content *ngIf="section.isCollapsed">
          <table class="table table-striped table-bordered">
            <thead class="thead-dark" *ngIf="[1] && !(section.sectionColumn[1].descriptionPlain=='Default')">
              <tr>
                <th *ngFor="let column of section.sectionColumn" scope="col">
                  <span>
                    <b>{{column.title}}</b>
                    <span class="fa-stack toolTipCursor"
                          (click)="openProtocolInformationWindow(evaluation.protocol, 'item' + section.sectionItemColumnDescription[1].sectionColumnItemType.sectionAlpha + section.sectionItemColumnDescription[1].sectionColumnItemType.itemNum)">
                      <i class="fa fa-square-o fa-stack-2x"></i>
                      <i class="fa fa-question fa-stack-1x"></i>
                    </span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sectionItem of section.sectionItem; let sii = index"
                  [ngClass]="isEmptyParent(section.id, sectionItem.id) ? 'tr-emptyparent' : ''"
                  [class.rowNotVisible]="isRowNotVisible(section.id, sectionItem.id)">
                <td *ngFor="let sectionColumn of section.sectionColumn; let ci = index" [ngClass]="isEmptyParent(section.id, sectionItem.id) ? 'tr-emptyparent ' +  getCssClassName(section.id, sectionItem.id, sectionColumn.id) : getCssClassName(section.id, sectionItem.id, sectionColumn.id)"
                    (click)="cellClicked(section.id, sectionItem.id, sectionColumn.id)">

                  <div *ngIf="ci==0" [ngClass]="isChildRow(section.id, sectionItem.id) ? 'tr-child ' : ''" class="">
                    {{sectionItem.title}}
                    <span class="fa-stack toolTipCursor"
                          *ngIf="sectionItem.descriptionHtml !=''"
                          (click)="openProtocolInformationWindow(evaluation.protocol, 'item' + section.sectionItemColumnDescription[sii].sectionColumnItemType.sectionAlpha + section.sectionItemColumnDescription[sii].sectionColumnItemType.itemNum)">
                      <i class="fa fa-square-o fa-stack-2x"></i>
                      <i class="fa fa-question fa-stack-1x"></i>
                    </span>
                  </div>


                  <div *ngIf="ci > 0">
                    <div class="row">
                      <div class="col-md-2">
                        <i class="fa fa-check fa-inverse fa-lg" *ngIf="isCellSelected(section.id, sectionItem.id, sectionColumn.id)"></i>
                      </div>
                      <div class="col-md-10">
                        <div class="pull-right usersSelectedCell"
                             *ngIf="!submissionId && getUsersThatSelectedCellCount(section.id, sectionItem.id, sectionColumn.id)>0">
                          <!--
                           For 2.2 release hide/show initials (added to the element above)
                          (click)="makeVisibleUsersThatSelectedCell(section.id, sectionItem.id, sectionColumn.id)"
                                                    <i class="fa fa-eye"></i>-->

                        </div>
                        <!--
                            For 2.2 release hide/show initials (added to the element below)
                            *ngIf="areUsersThatSelectedCellVisible(section.id, sectionItem.id, sectionColumn.id)"-->
                        <div>
                          <div class="pull-right usersSelectedCell" *ngFor="let user of getUsersThatSelectedCell(section.id, sectionItem.id, sectionColumn.id)">
                            {{user}}
                          </div>
                        </div>

                        <!--<br />
                        <div class="pull-right userSelectedCellBottomCount">
                          {{getUsersThatSelectedCellCount(section.id, sectionItem.id, sectionColumn.id)}}
                        </div>-->
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </mat-card-content>
      </mat-card>
      <br />
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12 action-btns-right" style="margin-top:5px;">
    <button *ngIf="!isWatchConsensus && !isSubmitted" mat-raised-button id="submitBtn" class="btn btn-success btn-extra-space-left" (click)="submitCoding()" [disabled]="isSubmitted || !codingSubmittable">Submit</button>
    <button *ngIf="evaluation.watchConsensusVisible" mat-raised-button [ngClass]="(watchConsensusEnabled) ? 'btn btn-success btn-extra-space-left' : 'btn btn-warning btn-extra-space-left'" (click)="watchConsensus()">Watch {{evaluation.startConsensusMergeVisible? "Comparison" :"Consensus"}}</button>
    <button *ngIf="evaluation.startConsensusMergeVisible" mat-raised-button class="btn btn-success btn-extra-space-left" (click)="startConsensus(evaluation.abstractId, evaluation.protocolId)">Start Comparison</button>
    <button *ngIf="evaluation.startConsensusVisible" mat-raised-button class="btn btn-success btn-extra-space-left" (click)="startConsensus(evaluation.abstractId, evaluation.protocolId)">Start Consensus</button>
    <button *ngIf="evaluation.abstract" mat-raised-button class="btn btn-primary" (click)="openAbstractInformationWindow(evaluation.abstractId)">View Abstract</button>
    <button *ngIf="evaluation && (canAddNotes() || canReadNotes())" mat-raised-button class="btn btn-primary" (click)="openDialog()">QC Notes {{evaluation.notes && evaluation.notes.length ? ' (' + evaluation.notes.length + ')' : ''}}</button>
    <button *ngIf="!isSubmitted && !isWatchConsensus" mat-raised-button class="btn btn-danger btn-extra-space-right" (click)="reset()">Reset</button>
    <div class="flagsBox" *ngIf="canRecommendForAdjudication() || canRecommendForReview()">
      <mat-checkbox *ngIf="canRecommendForReview()" class="checkbox-margin" [(ngModel)]="recommendedForODPReview" (click)="recommendForReview(evaluation.evaluationId)" [disabled]="disableODPReview()">QC Coder Question</mat-checkbox>
      <mat-checkbox *ngIf="canRecommendForAdjudication()" class="checkbox-margin" [(ngModel)]="recommendedForODPAdjudication" (click)="recommendForAdjudication(evaluation.evaluationId)" [disabled]="disableAdjudication()">Request ODP Adjudication</mat-checkbox>
    </div>
  </div>
</div>
<div class="row">
  <br />
  <br />
</div>
